import operations from '~/helpers/device-operations';
import { routerId, subtype, wifiChannel } from '~/helpers/fields-description';
import { FieldObject } from '~/interfaces/field.interface';
import { Gateway } from '~/models/gateways/gateway.model';
import { getServerNodeFields } from '~/models/helpers/network.function';

export class NMG extends Gateway {
    MAX_TIME_BEFORE_UNKNOWN = 6 * 3600;
    router_id?: string;
    hasSwitchDebugMode = true;
    hasOperationImportData = false;

    get deviceOperations() {
        return super.deviceOperations.concat([
            operations.dump({ callback: this.dump }),
            operations.setDump({ callback: this.setDump }),
            operations.orderReboot({ callback: this.orderReboot, disabled: this.isOrderRebootDisabled }),
            operations.getOEMInfos({ callback: this.getOEMInfos }),
        ]);
    }

    get typeToDisplay() {
        return this.subtype === 'standalone' ? 'Intuis Standalone Gateway - NMG' : this.type;
    }

    get fieldRouterId() {
        return routerId(this.router_id);
    }
    get fieldSubtype() {
        return subtype(this.subtype || 'legacy');
    }

    get fieldWifiChannel() {
        return wifiChannel(this.wifi_channel);
    }

    getNetworkFields(): FieldObject[] {
        let fields = super.getNetworkFields();
        if (this.network) {
            fields = fields.concat(getServerNodeFields(this.network.server_node));
        }
        return fields;
    }

}
